import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const CtrlSortFilterIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M22 0.25H2C1.59 0.25 1.25 0.59 1.25 1V3C1.25 3.17 1.31 3.34 1.41 3.47L9.25 13.26V23C9.24 23.47 9.73 23.85 10.18 23.73L14.18 22.73C14.51 22.65 14.75 22.35 14.75 22V13.26L22.59 3.47C22.7 3.34 22.75 3.17 22.75 3V1C22.75 0.59 22.41 0.25 22 0.25ZM21.25 2.74L13.41 12.53C13.3 12.66 13.25 12.83 13.25 13V21.41L10.75 22.03V12.99C10.75 12.82 10.69 12.65 10.59 12.52L2.75 2.74V1.75H21.25V2.74Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

CtrlSortFilterIcon.displayName = 'CtrlSortFilterIcon';
